export const SECTION_TEMPLATE_DATA = 'src/components/Scorecard/SectionTemplate/create/action/Section_Template_Form_Details';

export const setSectionTemplateData = (data) => {
    return {
        type: SECTION_TEMPLATE_DATA,
        data
    }
}
export const SECTION_TEMPLATE_SUCCESS = 'src/components/Scorecard/SectionTemplate/create/action/Section_Template_Success';
export const SECTION_TEMPLATE_ERROR = 'src/components/Scorecard/SectionTemplate/create/action/Section_Template_Error';

export const sectionTemplateSuccess = (data) => {
    return {
        type: SECTION_TEMPLATE_SUCCESS,
        data
    }
}
export const sectionTemplateError = (data) => {
    return {
        type: SECTION_TEMPLATE_ERROR,
        data
    }
}

export const SECTION_TEMPLATE_FILE = 'src/components/Scorecard/SectionTemplate/create/action/Section_Template_File';

export const setSectionTemplateFile = (data) => {
    return {
        type: SECTION_TEMPLATE_FILE,
        data
    }
}

export const SECTION_TEMPLATE_EDIT_DATA = 'src/components/Scorecard/SectionTemplate/create/action/Section_Template_Edit_Data';
export const setSectionTemplateEditData = (data) => {
    return {
        type: SECTION_TEMPLATE_EDIT_DATA,
        data
    }
}
export const SECTION_TEMPLATE_EDIT_SUCCESS = 'src/components/Scorecard/SectionTemplate/create/action/Section_Template_Success';
export const SECTION_TEMPLATE_EDIT_ERROR = 'src/components/Scorecard/SectionTemplate/create/action/Section_Template_Error';

export const sectionTemplateEditSuccess = (data) => {
    return {
        type: SECTION_TEMPLATE_EDIT_SUCCESS,
        data
    }
}
export const sectionTemplateEditError = (data) => {
    return {
        type: SECTION_TEMPLATE_EDIT_ERROR,
        data
    }
}

export const SECTION_TEMPLATE_CONFIGURATION = 'src/components/Scorecard/SectionTemplate/create/action/Section_Template_Configurationdata';
export const sectionTemplateConfig = (data) => {
    return {
        type: SECTION_TEMPLATE_CONFIGURATION,
        data
    }
}
export const SECTION_TEMPLATE_CONFIGURATION_SUCCESS = 'src/components/Scorecard/SectionTemplate/create/action/Section_Template_Configurationdata_Success';
export const SECTION_TEMPLATE_CONFIGURATION_ERROR = 'src/components/Scorecard/SectionTemplate/create/action/Section_Template_Configurationdata_Error';

export const sectionTemplateConfigSuccess = (data) => {
    return {
        type: SECTION_TEMPLATE_CONFIGURATION_SUCCESS,
        data
    }
}
export const sectionTemplateConfigError = (error) => {
    return {
        type: SECTION_TEMPLATE_CONFIGURATION_ERROR,
        error
    }
}


export const SECTION_TEMPLATE_TYPE = 'src/components/Scorecard/SectionTemplate/create/action/Section_Template_Type';
export const sectionTemplateType = (data) => {
    return {
        type: SECTION_TEMPLATE_TYPE,
        data
    }
}
export const SECTION_TEMPLATE_TYPE_SUCCESS = 'src/components/Scorecard/SectionTemplate/create/action/Section_Template_Type_Success';
export const SECTION_TEMPLATE_TYPE_ERROR = 'src/components/Scorecard/SectionTemplate/create/action/Section_Template_Type_Error';

export const sectionTemplateTypeSuccess = (data) => {
    return {
        type: SECTION_TEMPLATE_TYPE_SUCCESS,
        data
    }
}
export const sectionTemplateTypeError = (error) => {
    return {
        type: SECTION_TEMPLATE_TYPE_ERROR,
        error
    }
}

export const SECTION_TEMPLATE_MAPPING = 'src/components/Scorecard/SectionTemplate/create/action/Section_Template_Mapping';
export const SECTION_TEMPLATE_MAPPING_SUCCESS = 'src/components/Scorecard/SectionTemplate/create/action/Section_Template_Mapping_Success';
export const SECTION_TEMPLATE_MAPPING_FAILURE = 'src/components/Scorecard/SectionTemplate/create/action/Section_Template_Mapping_Failure';

export const setSectionTemplateMapping = (data) => {
    return {
        type: SECTION_TEMPLATE_MAPPING,
        data
    }
}
export const setSectionTemplateMappingSuccess = (data) => {
    return {
        type: SECTION_TEMPLATE_MAPPING_SUCCESS,
        data
    }
}
export const setSectionTemplateMappingFailure = (data) => {
    return {
        type: SECTION_TEMPLATE_MAPPING_FAILURE,
        data
    }
}

export const SECTION_TEMPLATE_MAPPING_EDIT = 'src/components/Scorecard/SectionTemplate/create/action/Section_Template_Mapping_Edit';
export const SECTION_TEMPLATE_MAPPING_EDIT_SUCCESS = 'src/components/Scorecard/SectionTemplate/create/action/Section_Template_Mapping_Edit_Success';
export const SECTION_TEMPLATE_MAPPING_EDIT_FAILURE = 'src/components/Scorecard/SectionTemplate/create/action/Section_Template_Mapping_Edit_Failure';

export const setSectionTemplateMappingEdit = (data) => {
    return {
        type: SECTION_TEMPLATE_MAPPING_EDIT,
        data
    }
}
export const setSectionTemplateMappingEditSuccess = (data) => {
    return {
        type: SECTION_TEMPLATE_MAPPING_EDIT_SUCCESS,
        data
    }
}
export const setSectionTemplateMappingEditFailure = (data) => {
    return {
        type: SECTION_TEMPLATE_MAPPING_EDIT_FAILURE,
        data
    }
}

export const GET_MASTER_DATA_KEY_VALUES = 'src/components/Scorecard/SectionTemplate/create/action/Get_Master_Data_Value';
export const GET_MASTER_DATA_KEY_VALUES_SUCCESS = 'src/components/Scorecard/SectionTemplate/create/action/Get_Master_Data_Value_Success';
export const GET_MASTER_DATA_KEY_VALUES_FAILURE = 'src/components/Scorecard/SectionTemplate/create/action/Get_Master_Data_Value_Failure';

export const getMasterDataValue = (data) => {
    return {
        type: GET_MASTER_DATA_KEY_VALUES,
        data
    }
}
export const getMasterDataValueSuccess = (data) => {
    return {
        type: GET_MASTER_DATA_KEY_VALUES_SUCCESS,
        data
    }
}
export const getMasterDataValueFailure = (data) => {
    return {
        type: GET_MASTER_DATA_KEY_VALUES_FAILURE,
        data
    }
}

export const UPDATE_API_KEY_NAME_OF_SECTION_TEMPLATE_REQUEST = 'src/components/Scorecard/SectionTemplate/create/action/UPDATE_API_KEY_NAME_OF_SECTION_TEMPLATE_REQUEST';
export const UPDATE_API_KEY_NAME_OF_SECTION_TEMPLATE_RESPONSE = 'src/components/Scorecard/SectionTemplate/create/action/UPDATE_API_KEY_NAME_OF_SECTION_TEMPLATE_RESPONSE';


export const updateAPIKeyNameRequest = (data) => {
    return {
        type: UPDATE_API_KEY_NAME_OF_SECTION_TEMPLATE_REQUEST,
        data
    }
}
export const updateAPIKeyNameResponse = (data) => {
    return {
        type: UPDATE_API_KEY_NAME_OF_SECTION_TEMPLATE_RESPONSE,
        data
    }
}